import * as z from "zod";

export const printReturnItemBarcodes = {
  name: "printReturnItemBarcodes" as const,
  input: z.object({
    returnId: z.string(),
    itemIds: z.array(z.string()).min(1),
    workstationId: z.string(),
  }),
  output: z.object({
    printedItemIds: z.array(z.string()),
    failedItemIds: z.array(z.string()),
  }),
};
